import { Extension } from '@tiptap/core';
import { undo as _undo, redo as _redo, history } from '@tiptap/pm/history';
var History = Extension.create({
  name: 'history',
  addOptions: function addOptions() {
    return {
      depth: 100,
      newGroupDelay: 500
    };
  },
  addCommands: function addCommands() {
    return {
      undo: function undo() {
        return function (_ref) {
          var state = _ref.state,
              dispatch = _ref.dispatch;
          return _undo(state, dispatch);
        };
      },
      redo: function redo() {
        return function (_ref2) {
          var state = _ref2.state,
              dispatch = _ref2.dispatch;
          return _redo(state, dispatch);
        };
      }
    };
  },
  addProseMirrorPlugins: function addProseMirrorPlugins() {
    return [history(this.options)];
  },
  addKeyboardShortcuts: function addKeyboardShortcuts() {
    var _this = this;

    return {
      'Mod-z': function ModZ() {
        return _this.editor.commands.undo();
      },
      'Mod-Z': function ModZ() {
        return _this.editor.commands.undo();
      },
      'Mod-y': function ModY() {
        return _this.editor.commands.redo();
      },
      'Mod-Y': function ModY() {
        return _this.editor.commands.redo();
      },
      'Shift-Mod-z': function ShiftModZ() {
        return _this.editor.commands.redo();
      },
      'Shift-Mod-Z': function ShiftModZ() {
        return _this.editor.commands.redo();
      },
      // Russian keyboard layouts
      'Mod-я': function ModЯ() {
        return _this.editor.commands.undo();
      },
      'Shift-Mod-я': function ShiftModЯ() {
        return _this.editor.commands.redo();
      }
    };
  }
});
export { History, History as default };